/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-console */

export class Log {
    public static LogLevel: {
        ERROR: number;
        WARN: number;
        DEBUG: number;
        INFO: number;
    } = {
        ERROR: 0, // ERROR
        WARN: 1, // ERROR, WARN
        DEBUG: 2, // ERROR, WARN, DEBUG
        INFO: 3, // ERROR, WARN, DEBUG, INFO
    };

    // __START_DEBUG_CODE_CLEANUP__
    private static defaultLogLevel = Log.LogLevel.INFO;
    // __END_DEBUG_CODE_CLEANUP__
    // __UNCOMMENT_DEBUG_CODE__
    // private static defaultLogLevel = Log.LogLevel.ERROR;

    public static setLogLevel(level: number): void {
        Log.defaultLogLevel = level;
    }

    private static getLogPrefix(): string {
        const d = new Date();
        const sDate = `${d.getDate()}`.padStart(2, '0');
        const sMonth = `${d.getMonth() + 1}`.padStart(2, '0');
        const sHour = `${d.getHours()}`.padStart(2, '0');
        const sMin = `${d.getMinutes()}`.padStart(2, '0');
        const sSec = `${d.getSeconds()}`.padStart(2, '0');
        const sMili = `${d.getMilliseconds()}`.padStart(3, '0');

        return `${d.getFullYear()}-${sMonth}-${sDate} ${sHour}:${sMin}:${sSec}.${sMili}  [KaveriWebApp] `;
    }

    private static shouldLog(level: number): boolean {
        return level <= Log.defaultLogLevel;
    }

    public static d(tag: string, message: string, ...optionalParams: any[]): void {
        if (Log.shouldLog(Log.LogLevel.DEBUG))
            console.debug(Log.getLogPrefix(), 'D ', tag, message, ...optionalParams);
    }

    public static e(tag: string, message: string, ...optionalParams: any[]): void {
        if (Log.shouldLog(Log.LogLevel.ERROR))
            console.error(Log.getLogPrefix(), 'E ', tag, message, ...optionalParams);
    }

    public static i(tag: string, message: string, ...optionalParams: any[]): void {
        if (Log.shouldLog(Log.LogLevel.INFO))
            console.info(Log.getLogPrefix(), 'I ', tag, message, ...optionalParams);
    }

    public static w(tag: string, message: string, ...optionalParams: any[]): void {
        if (Log.shouldLog(Log.LogLevel.WARN))
            console.warn(Log.getLogPrefix(), 'W ', tag, message, ...optionalParams);
    }
}
